import { Col, Layout, Row } from 'antd';
import SocialMediaIcons from 'components/SocialMediaIcons';
import { paths } from 'config';
import { useLocation } from 'react-router-dom';
import { I18nt } from 'utils';
import styles from './Layout.module.less';

function Footer() {
	const { pathname } = useLocation();
	const isHome = pathname !== paths.home;
	const footerDesktop = () => (
		<Row justify='space-between' className={styles.footerDesktop}>
			{isHome && (
				<Col lg={6} className={styles.footerSocialMedia}>
					<SocialMediaIcons footer />
				</Col>
			)}
			<Col lg={12}>
				<p className='text-align-center'>{I18nt('isbm')}</p>
				<p className='text-align-center'>{I18nt('direccion_isbm')}</p>
			</Col>
			<Col lg={6}>
				<p className='text-align-center'>{I18nt('tels_isbm')}</p>
				<p className='text-align-center'>{I18nt('email_isbm')}</p>
			</Col>
		</Row>
	);

	const footerMobile = () => (
		<Row className={styles.footerMobile}>
			<Col xs={24}>
				<p className='text-align-center'>{I18nt('isbm')}</p>
			</Col>
			<Col xs={24}>
				<p className='text-align-center'>{I18nt('direccion_isbm')}</p>
			</Col>
			<Col xs={24}>
				<p className='text-align-center'>{I18nt('tels_isbm')}</p>
			</Col>
			<Col xs={24}>
				<p className='text-align-center'>{I18nt('email_isbm')}</p>
			</Col>
		</Row>
	);

	return (
		<Layout.Footer className={styles.footer}>
			{footerMobile()}
			{footerDesktop()}
		</Layout.Footer>
	);
}

export default Footer;
